import React from 'react';
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTiktok,
  FaTwitter,
  FaYoutube,
} from 'react-icons/fa';

const profiles = {
  a4h: {
    facebook: 'https://www.facebook.com/Americans4Hindus',
    linkedin: 'https://www.linkedin.com/in/americans4hindus/',
    twitter: 'https://x.com/americans4hindu',
    tiktok: 'https://www.tiktok.com/@yourhandle',
    instagram: 'https://www.instagram.com/americans4hindus_a4h',
    youtube: 'https://www.youtube.com/@americans4hindusa4h',
  },
  fog: {
    facebook: 'https://www.facebook.com/fogsv.org?mibextid=wwXIfr',
    linkedin: 'https://www.linkedin.com/company/festival-of-globe/',
    twitter: 'https://x.com/fogsv?s=21&t=r3dLc7oxY1sZwtzDzC9lHA',
    tiktok: 'https://www.tiktok.com/@yourhandle',
    instagram: 'https://www.instagram.com/fogsv_org?igsh=NTc4MTIwNjQ2YQ==',
    youtube: 'https://www.youtube.com/@festivalofglobesiliconvall9424',
  },
};

const iconLinks = [
  { key: 'facebook', label: 'Facebook', Icon: FaFacebookF },
  { key: 'linkedin', label: 'LinkedIn', Icon: FaLinkedinIn },
  { key: 'twitter', label: 'X', Icon: FaTwitter },
  { key: 'tiktok', label: 'TikTok', Icon: FaTiktok },
  { key: 'instagram', label: 'Instagram', Icon: FaInstagram },
  { key: 'youtube', label: 'YouTube', Icon: FaYoutube },
];

function SocialProfileLinks({ brand = 'a4h' }) {
  const brandProfiles = profiles[brand] || profiles.a4h;

  return (
    <>
      <style>{`
        .social-profile-link {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          color: #fff !important;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          transition: transform 0.2s ease, opacity 0.2s ease;
        }

        .social-profile-link:hover {
          color: #fff !important;
          opacity: 0.85;
          transform: translateY(-1px);
        }

        .social-profile-link.facebook { background: #1877f2; }
        .social-profile-link.linkedin { background: #0077b5; }
        .social-profile-link.twitter { background: #000; }
        .social-profile-link.tiktok { background: #111; }
        .social-profile-link.instagram { background: #e4405f; }
        .social-profile-link.youtube { background: #ff0000; }
      `}</style>
      <ul className="social-list">
        {iconLinks.map(({ key, label, Icon }) => (
          <li key={key}>
            <a
              href={brandProfiles[key]}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              className={`social-profile-link ${key}`}
            >
              <Icon size={16} />
            </a>
          </li>
        ))}
      </ul>
    </>
  );
}

export default SocialProfileLinks;
